export const propertyDetails = {
  '1': {
    id: '1',
    title: 'شقة فندقية بإطلالة هادئة',
    type: 'شقة فندقية',
    location: 'حي الياسمين، الرياض، المملكة العربية السعودية',
    rating: 5,
    reviewCount: 48,
    breadcrumbs: ['الرئيسية', 'الحجوزات', 'شقة فندقية'],
    price: '2,520',
    currency: 'ريال',
    status: 'متاح للحجز',
    gallery: [
      '/image/2.jpg',
      '/image/1.jpg',
      '/image/3.jpg',
      '/image/2.jpg',
      '/image/1.jpg',
      '/image/3.jpg',
      '/image/1.jpg',
    ],
    videoLabel: 'شاهد الفيديو',
    views: '320',
    publishedAt: 'منذ 3 أيام',
    description:
      'شقة فندقية مصممة بعناية لتمنح الضيف إقامة هادئة وعملية، مع تشطيبات عصرية وإضاءة طبيعية ممتازة، وتقسيم داخلي مناسب للإقامات القصيرة والمتوسطة.',
    basicSpecs: [
      ['نوع العقار', 'شقة فندقية'],
      ['المساحة', '320 م²'],
      ['عدد الغرف', '4 غرف'],
      ['عدد الحمامات', '3 حمامات'],
      ['عدد الضيوف', '6 ضيوف'],
      ['الدخول الذاتي', 'متاح'],
      ['الدور', 'الدور الثالث'],
      ['مدة الإقامة', 'يومي / أسبوعي'],
    ],
    propertyAmenities: [
      'إنترنت سريع',
      'تكييف مركزي',
      'تلفاز ذكي',
      'موقف سيارة',
      'خدمة تنظيف',
      'مصعد',
      'حراسة 24/7',
      'مسبح مشترك',
    ],
    kitchenAmenities: [
      'ثلاجة كبيرة',
      'فرن كهربائي',
      'ميكروويف',
      'أدوات طهي كاملة',
      'ماكينة قهوة',
      'غلاية مياه',
    ],
    bathroomAmenities: [
      'مجفف شعر',
      'مناشف فندقية',
      'مستلزمات استحمام',
      'دش زجاجي',
      'مغسلة مزدوجة',
      'مياه ساخنة',
    ],
    features: [
      'إطلالة مفتوحة على الواجهة الرئيسية',
      'قريب من الخدمات والمطاعم',
      'أثاث حديث ومريح',
      'إضاءة طبيعية طوال اليوم',
      'ملائم للعائلات ورجال الأعمال',
    ],
    guestRatings: [
      {
        id: 'g1',
        name: 'عبدالله محمد',
        avatar: '/image/1.jpg',
        score: '5.0',
        date: 'منذ أسبوع',
        comment: 'المكان نظيف جداً، والإجراءات سريعة، والموقع ممتاز وقريب من كل الخدمات.',
      },
      {
        id: 'g2',
        name: 'سارة علي',
        avatar: '/image/2.jpg',
        score: '4.8',
        date: 'منذ أسبوعين',
        comment: 'التفاصيل مطابقة للصور، والشقة مريحة جداً للإقامة القصيرة والمتوسطة.',
      },
    ],
    mapImage:
      'https://maps.googleapis.com/maps/api/staticmap?center=24.774265,46.738586&zoom=12&size=1200x420&scale=2&maptype=roadmap&markers=color:blue%7C24.774265,46.738586',
    bookingSummary: {
      nights: '3 ليالٍ',
      guests: '2 ضيوف',
      checkIn: '23 يونيو 2026',
      checkOut: '26 يونيو 2026',
      cleaningFee: '120 ريال',
      serviceFee: '80 ريال',
      tax: '60 ريال',
      total: '7,820 ريال',
    },
    similarProperties: [
      {
        id: '2',
        image: '/image/1.jpg',
        tag: 'شقق فندقية',
        status: 'مميز',
        title: 'شقة فندقية',
        location: 'حي الياسمين',
        rating: 5,
        score: '5.0',
        area: '92.86 م²',
        beds: 5,
        baths: 4,
        price: '2,520',
        priceSuffix: 'ريال',
        period: 'ليلة',
        buttonLabel: 'عرض التفاصيل',
      },
      {
        id: '3',
        image: '/image/3.jpg',
        tag: 'شقق فندقية',
        status: 'مميز',
        title: 'شقة فندقية',
        location: 'حي الياسمين',
        rating: 5,
        score: '5.0',
        area: '92.86 م²',
        beds: 5,
        baths: 4,
        price: '2,520',
        priceSuffix: 'ريال',
        period: 'ليلة',
        buttonLabel: 'عرض التفاصيل',
      },
      {
        id: '4',
        image: '/image/2.jpg',
        tag: 'شقق فندقية',
        status: 'مميز',
        title: 'شقة فندقية',
        location: 'حي الياسمين',
        rating: 5,
        score: '5.0',
        area: '92.86 م²',
        beds: 5,
        baths: 4,
        price: '2,520',
        priceSuffix: 'ريال',
        period: 'ليلة',
        buttonLabel: 'عرض التفاصيل',
      },
    ],
  },
};

export const getPropertyDetails = (propertyId) => propertyDetails[propertyId] || propertyDetails['1'];
